import { render, staticRenderFns } from "./TaskPopup.vue?vue&type=template&id=60436884&scoped=true&"
import script from "./TaskPopup.vue?vue&type=script&lang=js&"
export * from "./TaskPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskPopup.vue?vue&type=style&index=0&id=60436884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60436884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60436884')) {
      api.createRecord('60436884', component.options)
    } else {
      api.reload('60436884', component.options)
    }
    module.hot.accept("./TaskPopup.vue?vue&type=template&id=60436884&scoped=true&", function () {
      api.rerender('60436884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/TaskPopup.vue"
export default component.exports